// @ts-nocheck
// Deployment Validator — Fase 15.9
import { validateEnterpriseDeployment } from '@/core/deployment/validateEnterpriseDeployment'
import { validateEnvironment }          from '@/core/env/environmentManager'
import { runCompatibilityCheck }        from '@/core/release/releaseManager'

export type DeployGate = 'env' | 'config' | 'browser_compat' | 'release_compat' | 'rollback_ready'
export interface DeployGateResult { gate: DeployGate; passed: boolean; message: string; details: string[] }
export interface ComprehensiveDeployReport {
  timestamp: string; environment: string; passed: boolean; gates: DeployGateResult[]
  blockers: string[]; warnings: string[]; readinessScore: number; recommendation: string
}

export function runDeploymentValidation(companyId?: string): ComprehensiveDeployReport {
  const gates: DeployGateResult[] = []; const blockers: string[] = []; const warnings: string[] = []
  const env = validateEnvironment()
  gates.push({ gate: 'env', passed: env.valid, message: env.valid ? 'Environment valid' : 'Missing vars', details: [...env.missing.map(m => 'Missing: ' + m), ...env.warnings] })
  if (!env.valid) blockers.push(...env.missing.map(m => 'Missing env: ' + m))
  warnings.push(...env.warnings)
  const dep = validateEnterpriseDeployment(companyId)
  gates.push({ gate: 'config', passed: dep.deployReady, message: dep.deployReady ? 'Config ready' : dep.blockers.length + ' blocker(s)', details: dep.blockers })
  if (!dep.deployReady) blockers.push(...dep.blockers)
  const wsOk = typeof WebSocket !== 'undefined'
  const lsOk = (() => { try { localStorage.setItem('_dv','1'); localStorage.removeItem('_dv'); return true } catch { return false } })()
  gates.push({ gate: 'browser_compat', passed: wsOk && lsOk, message: wsOk && lsOk ? 'Browser compatible' : 'Missing capabilities', details: [...(!wsOk ? ['WebSocket unavailable'] : []), ...(!lsOk ? ['localStorage unavailable'] : [])] })
  if (!wsOk || !lsOk) blockers.push('Browser incompatible')
  const compat = runCompatibilityCheck()
  gates.push({ gate: 'release_compat', passed: compat.compatible, message: compat.compatible ? 'Release compatible' : 'Compat issues', details: compat.checks.filter(c => !c.ok).map(c => c.message) })
  if (!compat.compatible) warnings.push(...compat.checks.filter(c => !c.ok).map(c => c.message))
  const hasMarker = compat.checks.find(c => c.name === 'rollback_marker_ready')?.ok ?? false
  gates.push({ gate: 'rollback_ready', passed: hasMarker, message: hasMarker ? 'Rollback marker present' : 'No validated rollback marker', details: hasMarker ? [] : ['Register and validate a rollback marker'] })
  if (!hasMarker) warnings.push('No rollback marker — recovery path undefined')
  const passed = gates.every(g => g.passed) && blockers.length === 0
  const score  = Math.round((gates.filter(g => g.passed).length / gates.length) * 100)
  return {
    timestamp: new Date().toISOString(), environment: env.environment, passed, gates, blockers, warnings,
    readinessScore: score,
    recommendation: passed ? 'DEPLOY APPROVED' : blockers.length > 0 ? 'BLOCK DEPLOY — ' + blockers.length + ' blocker(s)' : 'DEPLOY WITH CAUTION',
  }
}
